import { render, staticRenderFns } from "./handlePageIndex.vue?vue&type=template&id=665f1138&scoped=true"
import script from "./handlePageIndex.vue?vue&type=script&lang=js"
export * from "./handlePageIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665f1138",
  null
  
)

export default component.exports